import { ContentTopInfoBox } from './content/top-info-box';
import { InternHeadline } from './intern/headline';
import { InternImage } from './intern/image';
import { InternServiceLink } from './intern/service-link';
import { Tag } from './tag';

/**
 * Model definition for meta-card
 */
export interface MetaCard {
  __contentType: 'meta-card';
  id: string;
  name?: string;
  overline?: InternHeadline;
  headline?: InternHeadline;
  image?: InternImage;
  benefits?: ContentTopInfoBox;
  text?: string;
  links: InternServiceLink[];
  tags?: Tag[];
}

export function isMetaCard(obj: { __contentType?: string }): obj is MetaCard {
  return obj.__contentType === 'meta-card';
}
